import type { QueryClient } from '@tanstack/react-query';
import { marketQueryKeys } from '@/entities/market';
import { refreshTokens, useSessionStore } from '@/entities/session';
import { configureHttpAuth } from '@/shared/api';
import { loginPath } from '@/shared/config';

/**
 * Связь HTTP-интерсептора с сессией (shared не знает о сущности session):
 * access-токен — из стора; 401 → обновление по refresh-токену; неудача → выход и экран входа
 * с сохранением адреса (ТЗ ACC 4.7.1: «истёкшая сессия — возврат на экран входа с сохранением адреса»).
 */
export function connectSession(queryClient: QueryClient, navigate: (to: string) => unknown): void {
  configureHttpAuth({
    getAccessToken: () => useSessionStore.getState().accessToken,
    refreshAccessToken: async () => {
      const refreshToken = useSessionStore.getState().refreshToken;
      if (!refreshToken) return null;
      const tokens = await refreshTokens(refreshToken);
      useSessionStore.getState().setTokens(tokens);
      return tokens.access_token;
    },
    onAuthFailure: () => {
      useSessionStore.getState().clear();
      queryClient.removeQueries({
        predicate: (query) => query.queryKey[0] !== marketQueryKeys.config[0],
      });
      const current = `${window.location.pathname}${window.location.search}`;
      navigate(loginPath(current));
    },
  });
}
